// Every production deploy replaces the hashed asset bundle, and requests for a
// deleted chunk get the SPA fallback (index.html) instead of a 404. A session
// opened before the deploy then fails its next lazy import ("Failed to fetch
// dynamically imported module" / "'text/html' is not a valid JavaScript MIME
// type") and whatever surface needed the chunk silently breaks — see
// ONCALL-455. Vite dispatches `vite:preloadError` on window for both failed
// dependency preloads and the dynamic import itself (build only; the helper
// isn't used in dev), and a reload revalidates index.html, picking up the new
// bundle.
//
// The error is intentionally left propagating (no preventDefault) so Datadog
// RUM still records how often stale sessions hit this.
const RELOADED_AT_KEY = 'develo:stale-chunk-reloaded-at'
const RELOAD_LOOP_WINDOW_MS = 60_000

window.addEventListener('vite:preloadError', () => {
  // If a reload just happened and chunks still fail (e.g. the failure is not
  // deploy-related), reloading again would loop — let the error surface instead.
  const lastReloadAt = Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0)
  if (Date.now() - lastReloadAt < RELOAD_LOOP_WINDOW_MS) return
  sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()))
  window.location.reload()
})

// Lets the lazy layout fallback tell the user why the page is loading again.
// Storage can throw (blocked site data, some private modes); treat that as
// "no recent reload".
export const wasJustReloadedForStaleChunk = (now: number) => {
  try {
    const lastReloadAt = Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0)
    return now - lastReloadAt < RELOAD_LOOP_WINDOW_MS
  } catch {
    return false
  }
}
